import {Link, useNavigate, useParams} from "react-router-dom";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import React from "react";
import {Button} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useSwipe} from "../../hooks/useSwipe";
import {getUrl, PWAUrls,} from "../../config/urls";

const SwitchSecteur = ({i18n, route, isSwipeActive = true, details = false}) => {
    const history = useNavigate();
    const {slugregion, slugfalaise} = useParams();

    useSwipe({
        left: () => {
            if (!isSwipeActive || !route?.previousSlug) {
                return;
            }
            history(getSecteurLink(route.previousSlug));
        },
        right: () => {
            if (!isSwipeActive || !route?.nextSlug) {
                return;
            }

            history(getSecteurLink(route.nextSlug));
        },
    });

    const getSecteurLink = (toSlug) => {
        if (details) {
            return getUrl(PWAUrls.SECTOR_ROUTE_DETAILS, {lng: i18n.language, slugRegion: slugregion, slugGroupRoute: slugfalaise, slug: toSlug})
        } else {
            return getUrl(PWAUrls.SECTOR_ROUTE, {lng: i18n.language, slugRegion: slugregion, slugGroupRoute: slugfalaise, slug: toSlug})
        }
    }

    return (
        <>
            {(route?.previousSlug || route?.nextSlug) && <h3 className="secteur-navigation">
                {route.previousSlug && <Button component={Link} to={getSecteurLink(route.previousSlug)} variant="contained">
                    <FontAwesomeIcon icon={["fas", "arrow-left"]}  />
                </Button>}
                {route.nextSlug && <Button component={Link} to={getSecteurLink(route.nextSlug)} variant="contained">
                    <FontAwesomeIcon icon={["fas", "arrow-right"]} />
                </Button>}
            </h3>}
        </>)

        ;

}

export default
    compose(
        withTranslation(),
        )(SwitchSecteur);